export default __webpack_public_path__ + "static/1583-f8f29cdcc2fd9bfa2d616fce055e952b.gif";